import { render } from "./takat-banner.vue?vue&type=template&id=9bd6c204&scoped=true"
import script from "./takat-banner.vue?vue&type=script&lang=js"
export * from "./takat-banner.vue?vue&type=script&lang=js"

import "./takat-banner.vue?vue&type=style&index=0&id=9bd6c204&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd6c204"]])

export default __exports__